import "./checkphone.scss";
import { Form, Modal } from "react-bootstrap";
import cross from "images/cross.svg";

import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Formik } from "formik";

import { validationCode } from "../../Validation/index";

const CheckPhone = ({
  token,
  cleanErrorRegistration,
  checkPhoneCode,
  errorCode,
  approvePhoneCode,
  setCheckPhoneModal,
  approvedPhone,
  setSignInModal,
  setRegistrationModal,
  getUserData,
  ...props
}) => {
  const [newRequest, setNewRequest] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [blockedBtn, setBlockedBtn] = useState(false);

  useEffect(() => {
    if (approvedPhone === "0") {
      setSignInModal(false);
      setRegistrationModal(false);

      setCheckPhoneModal(true);
      cleanErrorRegistration();
    }
  });

  if (errorCode === "Код введен верно") {
    setCheckPhoneModal(false);
    cleanErrorRegistration();
    getUserData({ newToken: token });
  }
  if (errorCode === "Код введен неверно") {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      cleanErrorRegistration();
      setNewRequest(true);

      setSeconds(61);
    }
  }

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
      <Modal.Body className="signin">
        <p>
          <img
            src={cross}
            className="signin-img"
            onClick={() => {
              setNewRequest(false);

              cleanErrorRegistration();
              setCheckPhoneModal(false);
              setBlockedBtn(false);
            }}
          />
        </p>
        <Formik
          initialValues={{
            code: "",
          }}
          validateOnBlur
          onSubmit={async (values) => {
            await approvePhoneCode(values);
            setBlockedBtn(true);
          }}
          validationSchema={validationCode}
        >
          {({ values, errors, touched, handleChange, handleBlur, isValid, handleSubmit, dirty }) => (
            <div className="signin-form">
              <Form>
                <p className="registration-form-title">Для завершения регистрации подтвердите Ваш номер телефона</p>

                <Form.Group className="p-2 col-example text-left mb-3">
                  <Form.Label>Введите код, который мы отправили Вам на телефон</Form.Label>
                  <Form.Control
                    type="text"
                    name="code"
                    placeholder="Введите код"
                    className="input-form signin-placeholder"
                    isInvalid={touched.code && errors.code}
                    onChange={(e) => {
                      handleChange(e);
                      setBlockedBtn(false);
                    }}
                    onBlur={handleBlur}
                    value={values.code}
                  />
                  <Form.Control.Feedback type="invalid">{errors.code}</Form.Control.Feedback>
                </Form.Group>

                {errorCode === "Код введен неверно" ? (
                  <>
                    <Form.Group className="p-2 col-example mb-3">
                      <p className="signin-form-error">Код неверный</p>

                      <p className="checkphone-seconds">Повторная отправка возможна через {seconds} секунд</p>
                    </Form.Group>
                  </>
                ) : (
                  ""
                )}
                {newRequest ? (
                  <>
                    <Form.Group className="p-2 col-example mb-3">
                      <p
                        className="signin-link"
                        onClick={(e) => {
                          e.preventDefault();
                          Promise.all([checkPhoneCode()]);
                          values.code = "";
                          setNewRequest(false);
                          setBlockedBtn(false);
                        }}
                      >
                        Отправить код ещё раз
                      </p>
                    </Form.Group>
                  </>
                ) : (
                  ""
                )}
                <div>
                  <button className="signin-btn" type="submit" disabled={!isValid || !dirty || blockedBtn} onClick={handleSubmit}>
                    Готово
                  </button>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, modalWindows }) => {
  const {
    token,
    approvePhoneCode,
    approvedPhone,

    checkPhoneCode,
    cleanErrorRegistration,
    errorCode,
    error,
    isLoading,

    getUserData,
    getFiles,
    getStaticPage,
  } = usersStore;
  const { setCheckPhoneModal, setRegistrationModal, setSignInModal } = modalWindows;

  return {
    token,
    checkPhoneCode,
    cleanErrorRegistration,
    approvedPhone,

    approvePhoneCode,
    errorCode,
    error,
    isLoading,

    getUserData,
    getFiles,
    getStaticPage,

    setCheckPhoneModal,
    setRegistrationModal,
    setSignInModal,
  };
})(observer(CheckPhone));
